import { collection, query, where, getDocs, orderBy } from "firebase/firestore";
import Failure from "../../../core/Failure";
import { FirestoreCollections, firestore } from "../../../firebase.config";
import { IContact } from "@leedpulse-monorepo/interfaces";

async function getAllFavorite(): Promise<IContact[]> {
  try {
    const db = firestore;
    const contactsRef = collection(db, FirestoreCollections.contacts);
    const q = query(
      contactsRef,
      where("is_favorite_backoffice", "==", true),
      orderBy("last_activity.timestamp", "desc")
    );
    const querySnapshot = await getDocs(q);

    const favoriteContacts = querySnapshot.docs.map((doc) =>
      doc.data() as IContact
    );

    return favoriteContacts;
  } catch (e) {
    console.error("Erreur lors de la récupération des contacts favoris :", e);
    throw new GetAllFavoriteFailure();
  }
}

export class GetAllFavoriteFailure extends Failure {
  constructor(
    message = "Failed to fetch favorite conversations",
    code = "favorite-fetch-failure"
  ) {
    super(message, code);
  }
}

export default getAllFavorite;
